// extracted by mini-css-extract-plugin
export default {"modal":"pzscRkJS","externalLink":"nEdxEV5V","btns":"_6xQPkDi","partnerLink":"C0lC5OlP","desktop":"desktop"};